import { AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";

import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";


function* fetchJobListSaga(action: types.FetchJobListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IDataJobList> = yield call(services.getJobList, action.params);

        yield put(
            actions.fetchJobListSuccess({
                jobs: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchJobListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load extractors. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}


/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
  Allows concurrent increments.
*/


function* jobListSaga() {
    yield takeLatest(actionTypes.FETCH_JOB_LIST_REQUEST, fetchJobListSaga);
}


function* dataJobSaga() {
    yield all([
        jobListSaga(),
    ])
};

export default dataJobSaga;
